export function inSecondsToDate(seconds: number): Date {
  return new Date(new Date().getTime() + seconds * 1000);
}
